// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getNotifyStyle } from "@steiner/App/Components/Notify";
import { recentSavedCartStyles } from "@steiner/App/Widgets/Common/RecentSavedCarts";
// import { viewAllStyle } from "@steiner/XDL/Utilities/links";
import { css } from "styled-components";

recentSavedCartStyles.cardList = {
    gridContainer: {
        gap: 16,
    },
};

recentSavedCartStyles.noOrdersFoundText = {
    ...getNotifyStyle("info"),
};

recentSavedCartStyles.viewAllGridItem = {
    width: 12,
};

// recentSavedCartStyles.viewAllLink = {
//     ...viewAllStyle,
// };

recentSavedCartStyles.subtotalText = {
    color: "common.white",
    size: 12,
};

recentSavedCartStyles.subtotalTooltip = {
    mergeCss: true,
    cssOverrides: {
        tooltipContainer: css`
            pointer-events: none;
        `,

        tooltipClickable: css`
            margin-left: 8px;
            margin-right: 0;
        `,
    },
};
